import { render, staticRenderFns } from "./AccountsTab.vue?vue&type=template&id=89c9fa54&scoped=true&"
import script from "./AccountsTab.vue?vue&type=script&lang=ts&"
export * from "./AccountsTab.vue?vue&type=script&lang=ts&"
import style0 from "./AccountsTab.vue?vue&type=style&index=0&id=89c9fa54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c9fa54",
  null
  
)

export default component.exports